import { useEffect, useState } from 'react'
import { Typography } from '@pw-tech/omni-ui'
import { SUB_STATISTICS } from '@utils/translation'
import { useAmbassadorContext } from '@context/context'
import { filteritems } from '@utils/StaticDataSet'
import { PROFILE_STAGE } from '@utils/enum'
import StatisticsData from '../StatisticsData/StatisticsData'
import { FilterDropdown } from '@components/PerformanceReport/FilterDropDown/FilterDropDown'
import TermConditionModel from '@components/Common/Term&ConditionModel/Term&ConditionModel'

const Statistics = ({cameFrom}:{cameFrom?:string}) => {
  const { myProfileValue } = useAmbassadorContext()

  const [applyYearlyMetrics, setApplyYearlyMetrics] = useState<boolean>(false)
  const [startDateFilter, setStartDateFilter] = useState<string>('')
  const [endDateFilter, setEndDateFilter] = useState<string>('')
  const [isOpen, setIsOpen] = useState<boolean>(false)

  useEffect(() => {
    const last30Days = new Date()
    last30Days.setDate(last30Days.getDate() - 30)
    const lastDate = new Date()
    lastDate.setDate(lastDate.getDate() - 1)

    setStartDateFilter(last30Days.toISOString())
    setEndDateFilter(lastDate.toISOString())
    setApplyYearlyMetrics(false)
  }, [])

  return (
    <div>
      {/* <div className="flex justify-between  items-center gap-2 py-3 px-5 bg-[#FFF6E5] rounded-b-md">
        <span className="flex gap-2">
          <InformationCircleIcon className="right-0 w-5 h-5 my-auto" />
          <Typography variant={'regular'} weight={400}>
            {STATISTICS_ALERT_MESSAGE}
            <Typography weight={600}> {EFFECTIVE_FROM}</Typography>
          </Typography>
        </span>
        <span
          className="text-[#037CBF] hover:text-[#5A4BDA] pl-1 cursor-pointer text-[12px] sm:text-[16px] text-center"
          onClick={() => setIsOpen(true)}
        >
          {TERMS_CONDITIONS}
        </span>
      </div> */}

      <div className="py-[32px] px-[24px] rounded-md  bg-[#fff] gap-6 shadow-md">
        <div className="flex justify-between">
          <Typography variant={'heading3'} weight={'semi-bold'} color="#33333">
            {SUB_STATISTICS}
          </Typography>

          {myProfileValue?.programType !== PROFILE_STAGE.SAATHI_PROGRAM && (
            <div className="flex gap-5">
              <FilterDropdown
                items={filteritems}
                startDate={startDateFilter}
                endDate={endDateFilter}
                setStartDateFilter={setStartDateFilter}
                setEndDateFilter={setEndDateFilter}
                applyYearlyMetrics={(item: boolean) =>
                  setApplyYearlyMetrics(item)
                }
              ></FilterDropdown>
            </div>
          )}
        </div>
        <StatisticsData
          startDate={startDateFilter}
          endDate={endDateFilter}
          applyYearlyMetrics={applyYearlyMetrics}
          cameFrom={cameFrom}
        />
      </div>
      {isOpen && (
        <TermConditionModel
          isTermOpen={isOpen}
          onClose={() => setIsOpen(false)}
          cameFrom={'Statistics'}
        />
      )}
    </div>
  )
}
export default Statistics
